export interface MonitoringActiveWindowLike {
  activeUntilDate?: string | null;
  activeUntil?: string | null;
}

const resolveActiveUntil = (item: MonitoringActiveWindowLike) => {
  if (item.activeUntil) return item.activeUntil;
  if (item.activeUntilDate) return `${item.activeUntilDate}T23:59:59+09:00`;
  return "";
};

export const isMonitoringExpired = (item: MonitoringActiveWindowLike, referenceAt: Date = new Date()) => {
  const activeUntil = resolveActiveUntil(item);
  if (!activeUntil) return false;

  const activeUntilTime = new Date(activeUntil).getTime();
  if (Number.isNaN(activeUntilTime)) return false;

  return activeUntilTime < referenceAt.getTime();
};

export const formatMonitoringActivePeriod = (
  item: MonitoringActiveWindowLike,
  referenceAt: Date = new Date()
) => {
  if (isMonitoringExpired(item, referenceAt)) return "기간 만료";
  return item.activeUntilDate ? `${item.activeUntilDate}까지` : "무기한";
};
